<template lang="pug">
.general-form
  CountrySelector
  NumberOfBedrooms(v-if="countryCode")
  AgeOfHome(v-if="countryCode")
  HouseType(v-if="filteredHouseTypes.length && countryCode" :houseTypes="filteredHouseTypes")
  HouseTypology(v-if="houseTypeSelected != null")
  TermsAgreement(v-if="houseTypeSelected != null && houseTypologySelected != null")
</template>
<script lang="ts">
import { defineComponent } from "vue";
import AgeOfHome from "@/components/forms/questions/general/AgeOfHome.vue";
import HouseType from "@/components/forms/questions/general/HouseType.vue";
import HouseTypology from "@/components/forms/questions/general/HouseTypology.vue";
import TermsAgreement from "@/components/forms/questions/TermsAgreement.vue";
import { storeToRefs } from "pinia";
import { useSelections } from "@/store/selections";
import { useSettings } from "@/store/settings";
import { computed, onMounted } from "vue";
import CountrySelector from "./questions/general/CountrySelector.vue";
import NumberOfBedrooms from "./questions/general/NumberOfBedrooms.vue";

export default defineComponent({
  name: "GeneralFormUK",
  components: {
    AgeOfHome,
    HouseType,
    HouseTypology,
    TermsAgreement,
    CountrySelector,
    NumberOfBedrooms,
  },
  setup() {
    const { settings } = storeToRefs(useSettings());
    const { getHouseTypologies } = useSelections();
    const {
      countryCode,
      bedrooms,
      houseTypeSelected,
      filteredHouseTypes,
      houseTypologySelected,
      addressResult,
    } = storeToRefs(useSelections());

    const addressRequired = computed<boolean>(
      () => !!settings.value?.autoaddressKey
    );
    const isAddressValid = computed<boolean>(() => !!addressResult.value);

    onMounted(async () => {
      await getHouseTypologies();
    });
    return {
      countryCode,
      bedrooms,
      houseTypeSelected,
      filteredHouseTypes,
      houseTypologySelected,
      addressRequired,
      isAddressValid,
    };
  },
});
</script>
<style scoped lang="scss">
.general-form {
  display: flex;
  flex-direction: column;
}
</style>
